<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackspace_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.528 5.249c.234-.157.514-.249.815-.249h12.18C21.34 5 22 5.672 22 6.5v12c0 .828-.661 1.5-1.477 1.5H8.343c-.212 0-.413-.045-.595-.127a1.212 1.212 0 0 1-.143-.06c-.337-.172-.93-.863-1.359-1.363l-.118-.137-3.8-4.781a1.519 1.519 0 0 1-.017-1.864l3.817-4.98c.126-.128.255-.284.392-.45.29-.35.613-.742 1.008-.99Zm9.89 3.33a1 1 0 0 1 0 1.414l-2.362 2.363 2.363 2.363a1 1 0 0 1-1.414 1.414l-2.363-2.363-2.364 2.363a1 1 0 0 1-1.414-1.414l2.363-2.363-2.363-2.363a1 1 0 1 1 1.415-1.414l2.363 2.363 2.363-2.363a1 1 0 0 1 1.414 0Z"
        clip-rule="evenodd"
    />
</svg>
